export default {
  pagination_first: 'First',
  pagination_last: 'Last'
};
